export default __webpack_public_path__ + "assets/img/Segoe UI.293e692f583af77a347b4d8d325582d7.woff";